import { AdriverCustom, BooleanType } from '../../types';
import { ADRIVER_CATEGORIES_NAME, BUILDING_TYPE_ID, Cities } from './constants';
import { normalizeTargetingParameter } from './normalizeTargetingParameter';

export interface CreateAdriverCustomParams {
  leased?: string | null;
  rooms?: number | null;
  categoryId?: string | undefined;
  hasRepair?: BooleanType | null;
  cityName?: string | undefined;
  price?: number | null;
  hasBillOfSale?: boolean | undefined;
  hasMortgage?: boolean | undefined;
}

export function createAdriverCustom(
  params: CreateAdriverCustomParams
): AdriverCustom {
  const {
    leased,
    rooms,
    categoryId = BUILDING_TYPE_ID.FLAT_NEW,
    hasRepair,
    cityName,
    price,
    hasBillOfSale,
    hasMortgage
  } = params;

  return {
    1: leased === 'true' ? 'Kiraye' : 'Alis',
    5: rooms || NaN,
    6: ADRIVER_CATEGORIES_NAME[
      Number(
        categoryId || BUILDING_TYPE_ID.FLAT_NEW
      ) as keyof typeof ADRIVER_CATEGORIES_NAME
    ],
    7: hasRepair || 'false',
    8: normalizeTargetingParameter(cityName) || Cities.Baku.az,
    9: price || 0,
    10: hasBillOfSale ? 'true' : 'false',
    11: hasMortgage ? 'true' : 'false'
  };
}
